import { makeStyles } from '@material-ui/core/styles'
const useStyles = makeStyles(
  () => ({
    layout: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      paddingTop: '0.5em',
      '@media (max-width: 1400px)': {
        paddingLeft: '0.3em',
      },
      // border: '2px solid red',
    },
    downloadicon: { cursor: 'pointer' },
    downloadtext: {
      paddingLeft: '10px',
      color: '#707070',
      fontSize: '12px',
      '@media (max-width: 1400px)': {
        fontSize: '12px',
        paddingLeft: '6px',
      },
      letterSpacing: '0',
      fontWeight: 'bold',
      cursor: 'pointer',
    },
  }),
  { index: 1 },
)

export { useStyles }
